// Libraries
import {
  Component,
  Input
} from '@angular/core';

/**
 * `SidebarComponent` implements the sidebar view.
 */
@Component({
  selector: 'she-sidebar',
  template: require('./sidebar.component.html'),
  styles: [require('./sidebar.component.scss')]
})

export class SidebarComponent {
  /**
   * Store if view is collapsed or not.
   */
  @Input() isCollapsed = false;

  /**
   * Creates a new `SidebarComponent` instance.
   */
  constructor() {}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/admin/layout/sidebar/sidebar.component.ts